import { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { TextField, WithTooltip } from 'basic-components';
import { Calendar } from 'basic-components/icons';

import Modal from './Modal';

import { When } from 'react-if';

import './Cron.scss';

/* eslint-disable no-unused-vars */
const Cron = ({
  defaultValue,
  onChange,
  size = undefined,
  name,
  menuPosition = undefined,
  animationEnded,
  dependsOnParam,
  referenceDependsOnParam,
  withProvider,
  readableName,
  menuPortalTarget,
  ref,
  ...props
}) => {
/* eslint-enable no-unused-vars */
  const [isOpen, open] = useState(false),
        [value, setValue] = useState(defaultValue),
        onChangeText = useCallback(value => setValue(value), []),
        openModal = useCallback(() => open(true), [open]),
        closeModal = useCallback(() => open(false), [open])

  useEffect(() => {
    defaultValue !== value && value !== undefined && onChange(value, name)
  }, [value, onChange, defaultValue, name])

  return (
    <div className="data-science__pipeline-creator__body__options__resolver__bottom-row__cron">
      <TextField
          {...props}
          defaultValue={value}
          name="cron"
          onChange={onChangeText}
          placeholder="Type cron here"
          ref={ref}
          size={size}
      />
      <WithTooltip
          position="left"
          short
          text="Create cron expression"
      >
        <div 
            className="data-science__pipeline-creator__body__options__resolver__bottom-row__cron__icon"
            onClick={openModal}
        >
          <Calendar
              color="blue-bright"
              height={16}
              width={16}
          />
        </div>
      </WithTooltip>
      <When condition={isOpen}>
        {() => (
          <Modal
              closeModal={closeModal}
              defaultValue={defaultValue}
              onSubmit={setValue}
          />
        )}
      </When>
    </div>
  )
}

Cron.displayName = "Cron"


Cron.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  menuPosition: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.string,
}

export default memo(Cron);